import React from 'react';
import styles from '../ATSPage.module.css';
import { BulkAction } from '../hooks/useBulkActions';
import { AtsAction } from '../utils/atsUtils';

interface ATSBulkActionsProps {
  selectedCount: number;
  actions: BulkAction[];
  onClearSelection: () => void;
  onAction: (action: AtsAction) => void;
}

const ATSBulkActions: React.FC<ATSBulkActionsProps> = ({
  selectedCount,
  actions,
  onClearSelection,
  onAction,
}) => {
  if (selectedCount === 0) return null;

  return (
    <div className={styles.bulkActionBar} data-testid="ats-bulk-actions">
      <div className={styles.bulkActionInfo}>
        <span>
          {selectedCount} candidate{selectedCount > 1 ? 's' : ''} selected
        </span>
        <button className={styles.clearSelection} onClick={onClearSelection}>
          Clear
        </button>
      </div>
      <div className={styles.bulkActions}>
        {actions.map((action) => {
          const isPrimary = ['SCHEDULE_INTERVIEW', 'GENERATE_OFFER', 'RESCHEDULE'].includes(action.action);
          return (
            <button
              key={action.action}
              className={`${styles.bulkActionButton} ${isPrimary ? styles.bulkActionButtonPrimary : styles.bulkActionButtonSecondary}`}
              onClick={() => onAction(action.action)}
            >
              {action.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ATSBulkActions;
